<script setup lang="ts">
import Typography from '@afinius/ui-framework/Typography/Typography.vue';
import { useI18n } from 'vue-i18n';

import { useAppInfo } from '../../hooks/useAppInfo';

const appInfo = useAppInfo();
const { t } = useI18n();
</script>

<template>
  <div v-if="appInfo" class="app-info">
    <div class="app-info__logo-wrapper">
      <component
        :is="appInfo.logo"
        class="app-info__logo-wrapper__logo"
        :style="{ maxWidth: appInfo.logoMaxWidth }"
      />
    </div>

    <Typography isDark size="lg" tag="p">
      {{ t('afinius.app-explainer', { name: appInfo.name }) }}
    </Typography>
  </div>
</template>

<style lang="scss" scoped>
@use './AppInfo.scss';
</style>
